import React, {useContext} from 'react';
import {Stack} from '@mui/system';
import { useTheme } from '@mui/material';
import NavMenu from './NavMenu';
import UserContext from '@lib/contexts/userContext';

const Sidebar = ({ nav = true }) => {
  const { isLoggedIn } = useContext(UserContext);

  const theme = useTheme();

  const listStyles = {
    borderLeft: `1px solid ${theme.palette.ilorange.main}`,
    '& a .MuiListItemText-root': {
      marginBottom: '2px',
      marginTop: '2px',
      '& span': {
        fontSize: theme.typography.pxToRem(14),
      }
    },
  };

  const showNav = nav && isLoggedIn();

  return (
    <div id="left-sidebar" className={'sidebar'}>
      <Stack display={{ xs: 'none', sm: 'block' }}>
        {showNav && (
          <NavMenu listStyles={listStyles} />
        )}
      </Stack>
    </div>
  );
};

export default Sidebar;
